export const palette = {
  primary: {
    main: "#B77B1A",
    light: "#E7C36B",
    dark: "#7A4F00",
    contrastText: "#ffffff",
    red: "#B77B1A",
  },
  secondary: {
    main: "#1E2A26",
    light: "#4B5D56",
    dark: "#17211B",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#1F2522",
    secondary: "#5F6A63",
    800: "#2F3C36",
    neural_600: "#6D786F",
    neural_black: "#1A1D1B",
  },
  background: {
    default: "#ffffff",
    paper: "#F7F4EE",
  },
  neutral: {
    50: "#FCFBF8",
    100: "#F5F2EA",
    200: "#ECE6DC",
    300: "#DDD5C5",
    400: "#B6AA96",
    500: "#7F7566",
    600: "#5C5349",
    700: "#403B35",
    800: "#272421",
  },
};
